import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router';
import errorCover from "../images/errorCover.jpg";
import GameTooltip from './GameTooltip';

import './GameItem.scss';

function GameItem({ quest }) {
  const {
    coverPortrait,
    cover,
    name,
    gallery,
    id,
    releaseDate,
    description,
    categories,
    createdAt,
    updatedAt
  } = quest;

  const [isHovered, setIsHovered] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  // Filter the gallery array to include only items with type 'image'
  const imageGallery = gallery.filter(item => item.type === 'image');
  const [isRightEdge, setIsRightEdge] = useState(true);
  const itemRef = useRef(null);

  const formatDate = (date) => {
    if (!date) return ''
    const dateObj = new Date(date)
    const year = dateObj.getFullYear()
    const month = String(dateObj.getMonth() + 1).padStart(2, '0')
    const day = String(dateObj.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const getDisplayDate = () => {
    const tryFormat = (dateValue) => {
      const dateObj = new Date(dateValue);
      return isNaN(dateObj.getTime()) ? null : formatDate(dateValue);
    };
    let dateString = releaseDate || createdAt || updatedAt
    return tryFormat(dateString) || 'unknown';
  };
  const releaseDateDisplay = getDisplayDate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % imageGallery.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [imageGallery.length]);

  const handleMouseEnter = () => {
    setIsHovered(true);
    if (itemRef.current) {
      const rect = itemRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      console.log('rect.right', rect.right)
      const tooltipWidth = 350; // 你tooltip的大概宽度
      // 如果右边剩余空间不足 tooltipWidth，就往左展开
      setIsRightEdge(viewportWidth - rect.right < tooltipWidth);
    }
  };

  return (
    <div
      ref={itemRef}
      className={`game-cover ${isHovered ? 'hovered' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link to={`/game/${id}`}>
        <img
          src={coverPortrait || cover}
          alt="Game Cover"
          className="game-cover"
          onError={(e) => {
            e.target.src = errorCover;
          }}
        />
      </Link>
      {isHovered && (
        <GameTooltip
          isRightEdge={isRightEdge}
          coverPortrait={coverPortrait}
          cover={cover}
          errorCover={errorCover}
          name={name}
          imageGallery={imageGallery}
          currentImageIndex={currentImageIndex}
          description={description}
          categories={categories}
          releaseDate={releaseDateDisplay}
        />
      )}
    </div>
  );
}

export default GameItem;
